import styled from 'styled-components';
import { marginLeft, marginBottom } from '../../v2/foundation/spacing/utils.js';

var alignmentFromProps = function alignmentFromProps(props) {
  switch (props.$align) {
    case 'start':
      return 'flex-start';
    case 'end':
      return 'flex-end';
    case 'center':
      return 'center';
    default:
      throw Error("Unexpected prop `align`: " + props.$align);
  }
};
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1wdgl4l-0"
})(["display:flex;align-items:", ";justify-content:", ";flex-direction:", ";"], function (props) {
  return props.$direction === 'horizontal' && 'flex-end';
}, alignmentFromProps, function (props) {
  return props.$direction === 'vertical' && 'column';
});
var Item = styled.div.withConfig({
  displayName: "Item",
  componentId: "sc-1wdgl4l-1"
})(["display:inline-block;", " &:not(:first-child){", ";}&:not(:last-child){", ";}&:empty{margin:0;}"], function (props) {
  return props.$stretch && 'flex: 1;';
}, function (props) {
  return props.$direction === 'horizontal' && marginLeft(props.$spacing);
}, function (props) {
  return props.$direction === 'vertical' && marginBottom(props.$spacing);
});

export { Container, Item };
